import {ListSource} from "../../../../types";
import IconVocabulary from "../../../../assets/vocabulary.svg?react";
import {t} from "i18next";
import {RelatedGroup, RelatedItem} from "../../../../components/related-list";

type RelatedContentListProps = {
    results: ListSource[];
    showDebugIndicators?: boolean;
};

export const RelatedContentList = ({results, showDebugIndicators}: RelatedContentListProps) => {
    return (
        <RelatedGroup
            icon={<IconVocabulary style={{width: "1.2rem", height: "1.2rem"}} />}
            title={t("contextSidebar.OtherHeading")}
            items={results}
            keyExtractor={(r) => r.topicId}
            emptyText={t("contextSidebar.noRelatedContent")}
            renderItem={(result) => (
                <RelatedItem
                    title={result.topicTitle}
                    description={result.description}
                    href={result.url || "#"}
                    linkProps={{target: "_blank", rel: "noopener noreferrer"}}
                    debugScore={showDebugIndicators ? result.score : undefined}
                />
            )}
        />
    );
};
